
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class DzpkTable extends Vue {
    //德州扑克
    table = {
        data: [],
        column: [
            {
                key: 'dealer',
                title: '公共牌',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).desk_cards) {
                        poker = JSON.parse(params.row.opt_detail).desk_cards
                    }
                    return h('div', [
                        h('div', {
                            style: { marginTop: '5px' },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '庄家ID',
                align: 'center',
                render: (h, params) => {
                    let str = bulidUid(JSON.parse(params.row.opt_detail).banker) || ''
                    return h('div', [h('p', str)])
                }
            },
            {
                key: 'reason',
                title: '结算原因',
                align: 'center',
                render: (h, params) => {
                    let str = ''
                    let num = JSON.parse(params.row.opt_detail).reason || 0
                    if (num == 0) {
                        str = '正常结束'
                    } else if (num == 2) {
                        str = '主动弃牌'
                    } else if (num == 6) {
                        str = '正常超时弃牌'
                    } else if (num == 7) {
                        str = '掉线超时弃牌'
                    }
                    return h('div', [h('p', str)])
                }
            }
        ],
        column1: [
            {
                key: 'uid',
                title: '玩家ID',
                align: 'center',
                render: (h, params) => {
                    let str = bulidUid(params.row.uid)
                    return h('div', [
                        h('p', str),
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red'
                                }
                            },
                            String(params.row.uid).indexOf(String(params.row.user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                key: 'C',
                title: '手牌详情',
                align: 'center',
                width: 100,
                render: (h, params) => {
                    let strzo = params.row.data.C || []
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: strzo.map((x) => {
                                return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'CT',
                title: '牌型',
                align: 'center',
                render: (h, params) => {
                    return h('span', ['高牌', '一对', '两对', '三条', '顺子', '同花', '葫芦', '四条', '同花顺', '皇家同花顺'][params.row.data.CT - 1])
                }
            },
            {
                key: 'CT',
                title: '结算牌型',
                align: 'center',
                width: 250,
                render: (h, params) => {
                    let strzo = params.row.data.SortCards || []
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: strzo.map((x) => {
                                return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'Bet',
                title: '投注金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.Bet))
                }
            },
            {
                key: 'RealAWard',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.RealAWard))
                }
            },
            {
                key: 'PercentPoin',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.PercentPoin))
                }
            },
            {
                key: 'Tip',
                title: '操作',
                align: 'center',
                render: (h, params) => {
                    return h('span', ['没有操作', '普通下注', '跟注', '加注', 'allin', '让牌', '弃牌'][params.row.data.Tip])
                }
            }
        ]
    }
    getListData() {
        let obj3 = JSON.parse(this.listdata[0].opt_detail).users
        let arr3: any = []
        for (let i in obj3) {
            let Object = {
                user_id: this.listdata[0].user_id,
                uid: i,
                data: obj3[i]
            }
            arr3.push(Object)
        }
        return arr3
    }

    @Prop()
    listdata
}
